// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2DkXi","notes":"Notes_notes__363Sd"};